import { Pipe, PipeTransform } from '@angular/core';

/*
 * Returns the imgix url with parameters to blur for LQIP (Low Quality Image Placeholder)
*/
@Pipe({ name: 'blur' })
export class ImgixBlurPipe implements PipeTransform {
    constructor() {
    }
    transform(url: string, blur: number = 200, pixelatePixels: number = 16): string {    
      if (!this.isImgixUrl(url)) return url;
      return url + '&' + LQIPParameters.Blur + blur + '&' + LQIPParameters.Pixellate + pixelatePixels;
    }

    private isImgixUrl(url: string): boolean {
      return url.includes("imgix");
    }
}

enum LQIPParameters {
  Blur = 'blur=',
  Pixellate = 'px='
}